export const setCompletedTasks = {
  SET_COMPLETED_TASKS(state, payload) {
    state.tasksCompleted = payload;
  }
};
